import { useContext } from 'react';
import DynamicNftCollectionContext from '../contexts/DynamicNftCollectionContext';

const useDynamicNftCollectionContext = () =>
  useContext(DynamicNftCollectionContext);

export default useDynamicNftCollectionContext;
